import api from '../../../App/socket';

export const changeManagerLeadStatus = (id, shouldKill, margin) => {
    let update = {};

    if (shouldKill) {
        update = {
            kill_manager_special: true,
            is_manager_special: false,
            manager_special_last_date: new Date(),
            manager_special_margin: margin,
        };
    } else {
        update = {
            kill_manager_special: false,
            ref_lead_status: '5beabfe7f25bf5f49685abfb',
            is_manager_special: true,
            last_manager_special_date: new Date(),
            manager_special_margin: margin,
        };
    }

    return api.send({
        api: 'db',
        model: 'Lead',
        action: 'Update',
        options: {
            where: {
                _id: id,
            },
            update,
        },
    }).then(response => response).catch(error => error);
};

/*
Price
Reason For Selling


Pending
Priced
Exclude Manager Special
Delivery Requested
Arrange Collection
 */



// WEBPACK FOOTER //
// ./src/modules/Leads/Manager_special/requests/lead_manager_lead_status_request.js